import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight, Briefcase, MapPin, Layers, BookOpen } from 'lucide-react';
import { SERVICE_SEO } from '../data/serviceSeo';
import { SEGMENT_SEO } from '../data/segmentSeo';
import { LOCAL_SEO_CITIES } from '../data/localSeo';

// Malha de links internos entre serviços, áreas, cidades, conteúdos e a página comercial.
const SeoInternalLinks = ({ currentSlug }) => {
  const services = SERVICE_SEO.filter((s) => s.slug !== currentSlug);
  const segments = SEGMENT_SEO.filter((s) => s.slug !== currentSlug);
  const cities = LOCAL_SEO_CITIES.filter((c) => c.slug !== currentSlug);
  return (
    <section className="section-padding bg-white border-t border-slate-100" data-testid="seo-internal-links">
      <div className="container-hm">
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
          <div>
            <h3 className="flex items-center gap-2 text-base font-extrabold text-slate-900 mb-4">
              <Briefcase className="w-5 h-5 text-hm-orange" /> Serviços de recrutamento
            </h3>
            <ul className="space-y-2.5">
              {services.map((s) => (
                <li key={s.slug}>
                  <Link to={`/${s.slug}`} data-testid={`link-service-${s.slug}`} className="text-sm text-slate-600 hover:text-hm-orange hover:underline transition-colors">
                    {s.title}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
          <div>
            <h3 className="flex items-center gap-2 text-base font-extrabold text-slate-900 mb-4">
              <Layers className="w-5 h-5 text-hm-orange" /> Áreas de atuação
            </h3>
            <ul className="space-y-2.5">
              {segments.map((s) => (
                <li key={s.slug}>
                  <Link to={`/${s.slug}`} data-testid={`link-segment-${s.slug}`} className="text-sm text-slate-600 hover:text-hm-orange hover:underline transition-colors">
                    {s.title}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
          <div>
            <h3 className="flex items-center gap-2 text-base font-extrabold text-slate-900 mb-4">
              <MapPin className="w-5 h-5 text-hm-orange" /> Cidades no ABC
            </h3>
            <ul className="grid grid-cols-2 gap-x-4 gap-y-2.5">
              {cities.map((c) => (
                <li key={c.slug}>
                  <Link to={`/${c.slug}`} data-testid={`link-city-${c.slug}`} className="text-sm text-slate-600 hover:text-hm-orange hover:underline transition-colors">
                    {c.shortCity || c.city}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
          <div>
            <h3 className="flex items-center gap-2 text-base font-extrabold text-slate-900 mb-4">
              <BookOpen className="w-5 h-5 text-hm-orange" /> Explore mais
            </h3>
            <p className="text-sm text-slate-600 leading-relaxed mb-4">Conheça todos os serviços da HM Talent e conteúdos sobre recrutamento, seleção e gestão de pessoas.</p>
            <div className="flex flex-col gap-2.5">
              <Link to="/para-empresas" data-testid="link-para-empresas" className="inline-flex items-center gap-2 text-hm-orange font-semibold text-sm hover:underline">
                Página Para Empresas <ArrowRight className="w-4 h-4" />
              </Link>
              <Link to="/conteudos" data-testid="link-conteudos" className="inline-flex items-center gap-2 text-hm-orange font-semibold text-sm hover:underline">
                Conteúdos e artigos <ArrowRight className="w-4 h-4" />
              </Link>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default SeoInternalLinks;
